import * as React from "react";

const IconHeaderCaretSmallDown: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 9 6" fill="currentColor"><polygon fill="currentColor" points="3.749 4.498 4.078 4.162 7.171 1.007 7.5 .671 6.843 .002 6.514 .338 3.749 3.16 .984 .336 .655 0 0 .671 .329 1.007 3.42 4.164 3.749 4.5" transform="translate(.713 .71)"/></svg>;
};

export default React.memo(IconHeaderCaretSmallDown);
